import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('TAG').plugin(axiosPlugin);

let fetchStoryAction = redux.fetchActionGetOne();


export const TYPES = redux.types;

export const fetchTag = (id) => fetchStoryAction(`/tags/${id}`);
export const resetTag = () => redux.actions.reset();

export const tag = redux.reducer();